import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as biTemplateAdminActions from '../../actions/biTemplateAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/biTemplateAdmin/formPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import CheckBox from '../../components/common/inputs/checkBox';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class BiTemplateAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.biTemplateList,
      entityApiKey: "bi_template",      
      initialNewEntity: { system_dimension_metrics: [] },
      formHasChanges: false,
    };
  }
 
  async componentDidMount() {
    EntityTableTooling.fetchList(this);
    await this.props.actions.getPolynomialsList();
    await this.props.actions.getSystemDimensionMetrics({
      system_dimension_class: Constants.systemDimensionsIdentifiers.calculationUnit
    });
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "biTemplateAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "biTemplateAdmin.entityNamePlural"})),
      intl.formatMessage({id: "biTemplateAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""));
    
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.generateTemplate.status],
      [this.props.generateTemplate.status],
      null,
      intl.formatMessage({ id: "biTemplateAdmin.generateTemplateError" }),
      [() => {
        this.props.actions.setSaveEntityDataByKey("bi_template.polynomial_id", this.props.generateTemplate.data.polynomial_id);
        this.props.actions.setSaveEntityDataByKey("bi_template.polynomial_name", this.props.generateTemplate.data.polynomial_name);
        this.props.actions.setSaveEntityDataByKey("bi_template.polynomial_tree", this.props.generateTemplate.data.polynomial_tree);
      }]    
    );
  }
  
  recursiveHandlePolynomialTreeChange = (node, targetElementId) => {
    if(node.element_id == targetElementId) {
      node.display_report = !node.display_report;
    }
    else if(node.childs) {
      node.childs.forEach(child => {        
        this.recursiveHandlePolynomialTreeChange(child, targetElementId);
      });
    }
  };
  
  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.metriceditor) {
      let metricId = +event.currentTarget.dataset.path;
      let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
      let newMetricsSelected = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "bi_template.system_dimension_metrics")
      );
      if(!value) { 
        newMetricsSelected = newMetricsSelected.filter(item => item != metricId);
      } else {
        newMetricsSelected.push(metricId);
      }
      this.props.actions.setSaveEntityDataByKey("bi_template.system_dimension_metrics",newMetricsSelected);
      this.setState({ formHasChanges: true });
    }
    else if(event.currentTarget.dataset.templateeditor) {
      event.stopPropagation();
      let elementId = event.currentTarget.dataset.path;
      let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
      let newPolynomialTree = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "bi_template.polynomial_tree")
      );
      this.recursiveHandlePolynomialTreeChange(newPolynomialTree, elementId);
      this.props.actions.setSaveEntityDataByKey("bi_template.polynomial_tree",newPolynomialTree);
      this.setState({ formHasChanges: true });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleGenerateTemplate = (event) => {
    this.props.actions.generateTemplate({
      polynomial_id: this.props.save.data.bi_template.to_gen_polynomial_id ? this.props.save.data.bi_template.to_gen_polynomial_id : this.props.save.data.bi_template.polynomial_id 
    });    
  };

  render() {
    var loadingView = this.props.list.firstLoading ||
        this.props.polynomialsList.firstLoading ||
        this.props.systemDimensionMetrics.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.polynomialsList.status !== null && this.props.polynomialsList.status !== 200) ||
        (this.props.systemDimensionMetrics.status !== null && this.props.systemDimensionMetrics.status !== 200);
    return (
      <section className="dashboard_content_inner_view entity_admin_container bi_template_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                colorConfig={[{
                  color: "red",
                  column: "is_outdated",
                  value: true
                }]}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                handleGenerateTemplate={this.handleGenerateTemplate}
                generateTemplateData={this.props.generateTemplate}
                modelsData={this.props.polynomialsList.data}
                systemDimensionMetrics={this.props.systemDimensionMetrics.data.collection}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
              />        
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"biTemplateAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"biTemplateAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"biTemplateAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.bi_template && this.props.save.data.bi_template.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"biTemplateAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.bi_template && this.props.save.data.bi_template.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.biTemplateAdmin.list,
  save: state.reducer.biTemplateAdmin.save,
  delete: state.reducer.biTemplateAdmin.delete,
  polynomialsList: state.reducer.biTemplateAdmin.polynomialsList,
  systemDimensionMetrics: state.reducer.biTemplateAdmin.systemDimensionMetrics,
  generateTemplate: state.reducer.biTemplateAdmin.generateTemplate,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(biTemplateAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

BiTemplateAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BiTemplateAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/biTemplateAdmin/index.jsx